import useApiClient from './api-client'
import type { FbranchEatigoListData, RegionRegionInfoData, RegionRegionDetectInfo, SregionRegionsListInfo, RegionOtherRegionRes } from '@/types/api'
import type { GeolocationState } from '@/types/commons'

import { withCache } from './api-store'

export const getRegionList = async () => {
  const api = useApiClient<{ list: SregionRegionsListInfo[] }>()
  const apiCaller = () => api('/region')

  return withCache(apiCaller, {
    keyName: 'region-list',
    cacheTime: 12 * 60 * 60 * 1000, // cache 12 hours
  })
}

export const getRegion = async (id: number) => {
  const api = useApiClient<RegionRegionInfoData>()
  const apiCaller = () => api(`/region/${id}`, { method: 'GET' })

  return withCache(apiCaller, {
    keyName: `region-${id}`,
    cacheTime: 1 * 60 * 1000, // cache 1 minute
  })
}

export const getRegionPopular = async (id: number, params?: GeolocationState) => {
  const api = useApiClient<{ list: FbranchEatigoListData[] }>()
  const result = await api(`/region/${id}/popular`, { query: params })
  return result
}

export const getRegionDiscount = async (id: number, params?: GeolocationState) => {
  const api = useApiClient<{ list: FbranchEatigoListData[] }>()
  const result = await api(`/region/${id}/discount`, { query: params })
  return result
}

function extractIpOrHostname(cloudfrontAddr: string | undefined) {
  try {
    return new URL(`http://${cloudfrontAddr}`).hostname
  } catch {
    return undefined
  }
}

export const getRegionDetect = async () => {
  const api = useApiClient<RegionRegionDetectInfo>()
  const cloudfrontAddr = useRequestHeader('CloudFront-Viewer-Address') || ''
  const ip = extractIpOrHostname(cloudfrontAddr) || (useRequestHeader('x-forwarded-for')?.split(', ') || []).at(0)
  const query = { time_zone: getTimeZone(), ip }
  const result = await api(`/region-detect`, { query })
  return result
}

export const getRegionOtherCities = async (id: number, params: GeolocationState) => {
  const api = useApiClient<RegionOtherRegionRes>()
  const apiCaller = () => api(`/region/${id}/other-cities`, { query: params })

  const hasGeoInfo = !!params.lat || !!params.lng

  return withCache(apiCaller, {
    keyName: `region-${id}-other-cities`,
    cacheTime: 12 * 60 * 60 * 1000, // cache 12 hour
    params,
    useCache: !hasGeoInfo,
  })
}
